import React from 'react';

import { YOUTUBE, FACEBOOK, INSTAGRAM, TWITTER, SNAPCHAT } from '../../utils/static-configuration';

const AnalyticsAssetListHeader = ({ listName, listSize, openEngagementScoreModal }) => {
  if (!listName) return null;

  const youtubeHeaders = {
    first: { name: 'likes' },
    second: { name: 'dislikes' },
    third: { name: 'comments' },
    fourth: { name: 'views' },
    fifth: { name: 'engagement', showEngagementIcon: true },
  };

  const facebookHeaders = {
    first: { name: 'shares' },
    second: { name: 'likes' },
    third: { name: 'reactions' },
    fourth: { name: 'comments' },
    fifth: { name: 'views', showEngagementIcon: false },
  };

  const instagramHeaders = {
    first: { name: 'likes' },
    second: { name: 'comments' },
    third: { name: 'followers' },
    fourth: { name: 'views' },
    fifth: { name: 'engagement', showEngagementIcon: true },
  };

  const twitterHeaders = {
    first: { name: 'retweets' },
    second: { name: 'likes' },
    third: { name: 'replies' },
    fourth: { name: 'reach' },
    fifth: { name: 'engagement', showEngagementIcon: true },
  };

  const headerOptions = {
    YOUTUBE: youtubeHeaders,
    FACEBOOK: facebookHeaders,
    INSTAGRAM: instagramHeaders,
    TWITTER: twitterHeaders
  };

  const header = headerOptions[listName];
  const { first, second, third, fourth, fifth } = header;
  const renderListName = listName.toLowerCase();

  return (
    <div className="asset-list-header">
      <div className="flex-spacer">
        <img src={`/icons/${renderListName}-round.svg`} alt={renderListName} />
        <h2>&nbsp;{`${renderListName.charAt(0).toUpperCase()}${renderListName.slice(1)} (${listSize})`}</h2>
      </div>
      <div className="flex-item stat">
        <p>{ first.name }</p>
      </div>
      <div className="flex-item stat">
        <p>{ second.name }</p>
      </div>
      <div className="flex-item stat">
        <p>{ third.name }</p>
      </div>
      <div className="flex-item stat">
        <p>{ fourth.name }</p>
      </div>
      <div className="flex-item stat">
        <div className="info-hover-wrapper"><p>{ fifth.name }</p>{ fifth.showEngagementIcon && <div className="info-hover-icon" onClick={openEngagementScoreModal} /> }</div>
      </div>
      <div className="flex-item-small" />
    </div>
  );
};

export default AnalyticsAssetListHeader;



/** WEBPACK FOOTER **
 ** ./src/components/analytics-asset-list-header/index.js
 **/